var divider_viewer_rtlignore_default = {
  "divider-container": "_6N55H",
  "divider-container--double": "nq5g5",
  "divider": "ovTyF",
  "divider--single": "tzk1O",
  "divider--double": "Dyfq2",
  "divider--dashed": "i1if7",
  "divider--dotted": "y9kbN",
  "divider--small": "WnfXJ",
  "divider--medium": "W2CBS",
  "divider--large": "HnmkG",
  "divider--left": "eD-Z4",
  "divider--center": "_7kbs5",
  "divider--right": "G5IWN",
  "svgFixerContainer": "P1CK6",
  "emptyChar": "vz8oG"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
